<template>
  <svg aria-hidden="true" focusable="false" data-prefix="fas" :data-icon="nombre" class="w-16 h-16" role="img" xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox">
    <path fill="currentColor" :d="traza"></path>
  </svg>
</template>

<script>
export default {
  props: ["nombre"],
  data() {
    return {
      traza: "",
      viewBox: "0 0 512 512"
    };
  },
  mounted() {
    if (this.nombre === "minus-circle") {
      this.traza = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z";
      this.viewBox = "0 0 512 512";
    }
    if (this.nombre === "exclamation-triangle") {
      this.traza =
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z";
      this.viewBox = "0 0 576 512";
    }
  },
  methods: {
    click() {
      this.$emit("clickeado", this.numero);
    }
  }
};
</script>
